import { SvgIcon } from "@mui/material";

export default function PForPeep(props) {
  return (
    <SvgIcon {...props}>
      <path d="M14.4415 2H10.4167C7.98134 2 6 3.98134 6 6.41667V22L9.31343 20.9341V16.8794L15.7923 14.7973C17.6256 14.2077 18.8582 12.5174 18.8582 10.592V6.41667C18.8582 3.98134 16.8769 2 14.4415 2ZM15.5448 10.5933C15.5448 11.0746 15.2376 11.4963 14.7786 11.643L9.31343 13.3993V6.41667C9.31343 5.80846 9.80846 5.31343 10.4167 5.31343H14.4403C15.0485 5.31343 15.5435 5.80846 15.5435 6.41667V10.5933H15.5448Z" />
    </SvgIcon>
  );
}
